export default function CarouselStyle(
    card: React.CSSProperties,
    CARD_WIDTH: number
) {
    const carouselStyle: React.CSSProperties = {
        ...card,
        minWidth: CARD_WIDTH,
        maxWidth: CARD_WIDTH,
        flex: '0 0 auto',
        userSelect: 'none',
    };
    return carouselStyle;
};
